import {
  Text as ChakraText,
  TextProps as ChakraTextProps,
} from "@chakra-ui/react";
import { bluePop } from "consts";
import { useState } from "react";

interface TextProps extends ChakraTextProps {
  textStyle: "h1" | "h2" | "h3" | "h4" | "p";
  clickable?: boolean;
}

const h1Props = {
  fontFamily: "Instrument Serif",
  fontSize: { base: "60px", sm: "80px", md: "100px" },
  fontWeight: 100,
  letterSpacing: "-0.02em",
  lineHeight: 0.9,
};

const h2Props = {
  fontFamily: "Instrument Serif",
  fontSize: { base: "40px", sm: "50px" },
  fontWeight: 300,
  letterSpacing: "-0.02em",
  lineHeight: 0.9,
};

const h3Props = {
  fontFamily: "Instrument Serif",
  fontSize: "35px",
  fontWeight: 400,
  letterSpacing: "-0.01em",
  lineHeight: 0.9,
};

const h4Props = {
  fontSize: "10.5px",
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase",
};

const pProps = {
  fontSize: "20px",
  fontWeight: 400,
  letterSpacing: "0.01em",
  lineHeight: 1.2,
};

// h5 {
//   font-size: 9px;
//   font-weight: 700;
//   letter-spacing: 0.2em;
//   text-transform: uppercase;
// }

// h6 {
//   font-size: 24px;
//   font-weight: 400;
// }

const textStyleMap = {
  h1: h1Props,
  h2: h2Props,
  h3: h3Props,
  h4: h4Props,
  p: pProps,
};

export const Text = ({ textStyle, clickable = false, ...props }: TextProps) => {
  const resolvedTextStyle = textStyleMap[textStyle];
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const hoverColor = clickable && isHovered ? { color: bluePop } : {};

  return (
    <ChakraText
      fontFamily="Google Sans"
      fontStyle="normal"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      cursor={clickable ? "pointer" : "default"}
      transition="color 0.2s"
      {...hoverColor}
      {...props}
      {...resolvedTextStyle}
    />
  );
};
